import AllConversations from '../../../assets/customSVG/inbox/AllConversations';
import Unassigned from '../../../assets/customSVG/inbox/Unassigned';
import { ICONS } from '../../../assets/icons';
import Resolved from '../../../assets/customSVG/inbox/Resolved';
import Favourite from '../../../assets/customSVG/inbox/Favourite';
import Unread from '../../../assets/customSVG/inbox/Unread';

export const webChatSidebar = [
  {
    id: 1,
    name: 'Conversations',
    icon: ICONS?.sidebarChevronDown,
    subMenu: [
      {
        id: 1,
        Icon: AllConversations,
        name: 'All Conversations',
        key: 'ALCONV',
        isSelected: false,
        count: 0,
      },
      {
        id: 2,
        Icon: Resolved,
        name: 'Your Inbox',
        key: 'MYINBX',
        isSelected: false,
        count: 0,
      },
      {
        id: 3,
        name: 'Unread',
        key: 'URED',
        isSelected: false,
        Icon: Unread,
        count: 0,
      },
      {
        id: 4,
        name: 'Unassigned',
        key: 'UASS',
        isSelected: false,
        Icon: Unassigned,
      },
      {
        id: 6,
        name: 'Favorite',
        key: 'FAV',
        isSelected: false,
        Icon: Favourite,
        count: 0,
      },
    ],
  },

  { id: 2, name: 'Teams', subMenu: [] },
];

export const participant_types = {
  1: 'SYSTEM_USER',
  2: 'END_USER',
  3: 'AGENT',
};

export const messageStatus = {
  1: 'new',
  5: 'sent',
  8: 'delivered',
  10: 'read',
};
